import { t, tEn } from '../i18n/translations'

const KIDASE_GROUPS = [
  { groupId: 'sirate-kidase', titleKey: 'sirateKidase', categoryIds: [1, 3] },
  { groupId: 'kidase-hawariat', titleKey: 'kidaseHawariat', categoryIds: [2, 4] }
]

export default function CategoryList({ categories, activeId, onSelect, getCategoryStats }) {
  return (
    <nav className="category-list">
      {KIDASE_GROUPS.map((group) => {
        const groupCategories = group.categoryIds
          .map(id => categories.find(c => c.id === id))
          .filter(Boolean)

        if (groupCategories.length === 0) return null

        return (
          <div key={group.groupId} className="category-group" data-group={group.groupId}>
            <div className="group-header">
              <span className="group-title" title={tEn(group.titleKey)}>{t(group.titleKey)}</span>
            </div>

            {groupCategories.map((cat) => {
              const melody = (cat.id === 3 || cat.id === 4) ? t('categoryEzli') : t('categoryGeez')

              const stats = getCategoryStats ? getCategoryStats(cat.chants?.map(c => c.id) || []) : null
              const pct = stats && stats.total > 0 ? Math.round((stats.completed / stats.total) * 100) : 0

              return (
                <button
                  key={cat.id}
                  aria-pressed={activeId === cat.id}
                  className={`category-btn ${activeId === cat.id ? 'active' : ''}`}
                  onClick={() => onSelect(cat.id)}
                >
                  <span className="melody-badge" title={tEn(cat.id === 3 || cat.id === 4 ? 'categoryEzli' : 'categoryGeez')}>{melody}</span>
                  <span className="category-meta"><span className="category-count">{cat.chants?.length || 0}<span className="sr-only"> {t('chantsCount')}</span></span><span className="category-ring" style={{ '--progress': pct + '%' }} aria-label={pct + '%'}><span>{pct}%</span></span></span>
                  {stats && stats.completed > 0 && (
                    <span className="category-progress sr-only">{stats.completed}/{stats.total} ({pct}%)</span>
                  )}
                </button>
              )
            })}
          </div>
        )
      })}
    </nav>
  )
}
